import React from 'react'
import { Container, Grid, Box, Typography } from '@mui/material'
import HeaderBack from '../../components/global/HeaderBack'
// import MainHeader from '../../components/global/MainHeader';
import iconLogin from './../../assets/auth/illustration-dashboard.webp'
import FormLogin from '../../components/auth/FormLogin';
// import WrapperSection from '../../components/global/WrapperSection';

const Login = () => {
  return (
    <>
      <HeaderBack />
      <Container maxWidth="lg">
        <Grid
          container
          spacing={{ md: 4, xs: 2 }}
          alignItems="center"
          justifyContent="center"
          sx={{ minHeight: 'calc(100dvh - 45px)' }}   // بدل 70vh
        >
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
              }}
            >
              <Typography variant="h4" mb={2}>
                Welcome Back
              </Typography>
              <Typography variant="body1" color="text.secondary">
                Login to access your dashboard and manage your account.
              </Typography>
              <Box
                component="img"
                src={iconLogin}
                alt="Login"
                sx={{
                  mb: 3,
                  maxWidth: '100%',
                  height: 'auto',
                  display: { xs: 'none', md: 'block' },
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <FormLogin />
          </Grid>
        </Grid>
      </Container>
    </>
  );
};


export default Login
